import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiCallGetAdminUsageData } from "../../../api/developer-api/api-call-get-admin-usage-data";
import { getSpecificDateWithDays } from "../../../core/et3-date";
import { isDateRangeValid } from "../../../helpers/et3-date-helper";
import {
  TAdminSubTabAccessData,
  TAdminGeneratedTablesData
} from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class AdminUsageStore {
  adminSubTabAccessData = observable.box<TAdminSubTabAccessData>([]);
  adminGeneratedTablesData = observable.box<TAdminGeneratedTablesData>([]);
  fromDate = observable.box<Date>(
    getSpecificDateWithDays({
      daysSubtracted: 1,
      daysAdded: 0
    })
  );
  toDate = observable.box<Date>(
    getSpecificDateWithDays({ daysSubtracted: 0, daysAdded: 1 })
  );

  setAdminUsageData = (data: {
    adminSubTabAccessData: TAdminSubTabAccessData;
    adminTableGenerationData: TAdminGeneratedTablesData;
  }) => {
    runInAction(() => {
      this.adminSubTabAccessData.set(data.adminSubTabAccessData);
      this.adminGeneratedTablesData.set(data.adminTableGenerationData);
    });
  };

  getAdminUsageData = async () => {
    if (
      !isDateRangeValid({
        fromDate: this.fromDate.get(),
        toDate: this.toDate.get(),
        isLimitedToOneMonth: false
      })
    ) {
      return;
    }

    getCoreUIStore().setIsLoading("DEVELOPER_ADMIN_USAGE_DATA", true);
    const { status, data, code } = await apiCallGetAdminUsageData({
      startDate: this.fromDate.get(),
      endDate: this.toDate.get()
    });
    getCoreUIStore().setIsLoading("DEVELOPER_ADMIN_USAGE_DATA", false);
    if (status === "OK") {
      this.setAdminUsageData(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
}

const getAdminUsageStore = memoize(
  () => new AdminUsageStore(),
  () => 1
);
export default getAdminUsageStore;
